// Most recently approved feed categories, kept in localStorage so the admin review flow can offer
// them as one-click shortcuts. Reviewing tends to come in runs of similar feeds, so the last few
// categories are by far the most likely next pick.
//
// Newest first, deduplicated, capped at MAX_RECENT_CATEGORIES.

const RECENT_CATEGORIES_KEY = 'admin-recent-categories';

export const MAX_RECENT_CATEGORIES = 3;

/** Recently approved categories, newest first. Empty if none/invalid. */
export function getRecentCategories(): string[] {
  try {
    const stored = JSON.parse(window.localStorage.getItem(RECENT_CATEGORIES_KEY) || '[]');
    if (!Array.isArray(stored)) return [];
    return stored.filter(c => typeof c == 'string' && c).slice(0, MAX_RECENT_CATEGORIES);
  } catch {
    return [];
  }
}

/** Records an approved category as the newest one. Returns the updated list. */
export function recordRecentCategory(category: string | undefined): string[] {
  const current = getRecentCategories();
  if (!category) return current;
  const updated = [category, ...current.filter(c => c != category)].slice(0, MAX_RECENT_CATEGORIES);
  try {
    window.localStorage.setItem(RECENT_CATEGORIES_KEY, JSON.stringify(updated));
  } catch { /* ignore */ }
  return updated;
}
